const initialState = {
    statusShow: false,
    transactions:{},
    total:0,
    total_rows:0,
    offset:0,
    carrot:[],
    loader:false,
};
const modalMyWallet = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_MY_WALLET':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_MY_WALLET':
            return {...state, statusShow: false};
        case 'CHANGE_DATA_WALLET':
            return {
                ...state,
                transactions: action.transactions,
                total: action.total,
                total_rows: action.total_rows,
                offset: action.offset,
                carrot: action.carrot
            };
        case 'CHANGE_LOADER_MODAL_WALLET':
            return{...state,loader:action.loader};
        default:
            return state;
    }
};

export default modalMyWallet;